// extracted by mini-css-extract-plugin
module.exports = {"container":"KeywordSearchGroup_container__2G9vX","sending":"KeywordSearchGroup_sending__MYBH_"};